// react and mui stuff
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../utils/contexts";
import { ToastContext } from "../components/toast";

import Button from "@mui/joy/Button"
import Checkbox from "@mui/joy/Checkbox"
import IconButton from "@mui/joy/IconButton"
import Typography from "@mui/joy/Typography"

import Edit from "@mui/icons-material/Edit"
import GppBad from "@mui/icons-material/GppBad"

// custom components
import { MetaProps } from "../components/metaprops";
import UserCard from "../components/usercard";

// data and stuff
import { BaseUser, CliUser } from "../types/users";
import { PHBaseUsers } from "../data/placeholderusers";
import { setData } from "../utils/setdata";
import { auditAPI, userAPI } from "../utils/backend";

export default function NameAudit() {
  const { setToast } = useContext(ToastContext);
  const { user, setUser } = useContext(UserContext);
  const [users, setUsers] = useState<BaseUser[]>(PHBaseUsers());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // get data
    if (!user) return;
    auditAPI.getUsernames().then(info => {
      if (!setData(info, setToast, user, setUser)) return;
      
      // set stuff
      setUsers(info)
      setLoading(false)
    });
  }, [setToast, setUser, user]);

  function updateNames(users: { name?: string, id: string }[]) {
    setLoading(true);

    // send the info off
    auditAPI.setUsernames(users).then(info => {
      if (!setData(info, setToast, user, setUser, () => setLoading(false))) return;
      
      // yipee
      setUsers(info);
      setToast({ text: "Usernames have been updated!", color: "success" });
      setLoading(false);
    })
  }

  function editName(user: BaseUser) {
    // probably replace this with something nicer at some point but this works for now
    let name = prompt("What should this users's new name be?", user.displayName)?.slice(0, 32);
    
    // canceled
    if (name === undefined) return;
    
    // submitted. if it's blank the backend will assign a random name
    updateNames([{ name: name || undefined, id: user.id }]);
  }

  function confirmKick(user: BaseUser, cliUser: CliUser | null | undefined) {
    const confirmed = window.confirm(`Are you sure you want to kick ${user.displayName}?`);
    if (!confirmed) return;

    setLoading(true);
    const reason = "Innapropriate username";

    userAPI.kick(user.id, reason).then(status => {
      if (!setData(status, setToast, cliUser, setUser, () => setLoading(false))) return;

      // get new info
      auditAPI.getUsernames().then(info => {
        if (!setData(info, setToast, cliUser, setUser, () => setLoading(false))) return;
        
        setUsers(info);
        setLoading(false);
      });
    });
  }

  return (
    <div className="contentRoot">
      <MetaProps meta={{
        splash: "april fools",
        title: "Name Audit",
        url: "mod/names",
        description: "Get a list of innapropriate usernames in the server"
      }}
      />
      <h1 className="pageTitle">Username Audit</h1>
      { users.length === 0 && <Typography level="h2">You're all caught up!</Typography> }
      { users.length > 0 &&
        <>
          <Typography>This is a list of all users with possible profanity in their name.</Typography>
          
          <br/>
          <form onSubmit={(e) => {
            e.preventDefault();
            const form = new FormData(e.currentTarget);
            const selected = Array.from(form.keys());

            if (selected.length === 0) return setToast({ text: "You need to select at least one person for batch renaming!", color: "danger" });
            updateNames(selected.map(u => ({ id: u })));
          }}>
            <Button type="submit" loading={loading}>Batch Update</Button>

            <br/>
            <br/>
            <div>
              {users.map(u => {
                const loading = u.id.length < 3;
                return (
                  <div className="flexMidVert" key={u.id} style={{ marginBottom: "10px" }}>
                    <Checkbox name={u.id} sx={{marginRight: "10px"}}/>
                    <UserCard profile={u} sx={{ flexGrow: 1 }} loading={loading}/>
                    <IconButton loading={loading} onClick={() => editName(u)}><Edit /></IconButton>
                    <IconButton loading={loading} onClick={() => confirmKick(u, user)}><GppBad /></IconButton>
                  </div>
                );
              })}
            </div>
          </form>
        </>
      }
    </div>
  )
}